import React, { Component } from "react";
import { Button, Row, Col, Table } from "react-bootstrap";
import { SearchBar } from "../../SearchBar";
import { SortHelper } from "../../helpers/SortHelper";

export class GenericSelectableTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sortField: null,
            sortDirection: "asc",
            showSortMenu: false
        };

        this.sortMenuRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', (e) => this.onClickOutside(e));

        const { sortableFields } = this.props;

        if (sortableFields && sortableFields.length > 0) {
            this.setState({
                sortField: sortableFields[0].value
            });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', (e) => this.onClickOutside(e));
    }

    onClickOutside(event) {
        if (this.sortMenuRef.current && !this.sortMenuRef.current.contains(event.target)) {
            this.setState({
                showSortMenu: false
            });
        }
    }

    onToggleSortMenu() {
        this.setState({
            showSortMenu: !this.state.showSortMenu
        });
    }

    onSort(field, direction) {
        this.setState({
            sortField: field !== null ? field : this.state.sortField,
            sortDirection: direction !== null ? direction : this.state.sortDirection,
            showSortMenu: false
        });
    }

    getSortedData() {
        const { data, sortableFields } = this.props;
        const { sortField, sortDirection } = this.state;

        if (undefined === data || data.length === 0) {
            return [];
        }

        if (undefined === sortableFields || 0 === sortableFields.length || undefined === sortField) {
            return data;
        }

        const options = {
            property: sortField,
            type: sortDirection === "asc" ? "ascending" : "descending"
        };

        return data.slice().sort((a, b) => SortHelper.sort(options, a, b));
    }

    render() {
        const { onRowClick, isRowSelected = () => false, onSearch, onSelectAll, sortableFields = [] } = this.props;
        const { sortField, sortDirection, showSortMenu } = this.state;

        const isClickable = typeof onRowClick === "function";
        const showSort = sortableFields && sortableFields.length > 0;

        const sortedData = this.getSortedData();

        return (
            <div className="margin-top-15 margin-left-15 margin-right-15">
                <Row className="d-flex mb-3">
                    {typeof onSearch === "function" && (
                        <Col xs={4} sm={4} md={3}>
                            <SearchBar onSearch={(a) => onSearch(a)} />
                        </Col>
                    )}

                    {showSort && (
                        <div className="sort-menu-wrapper" ref={this.sortMenuRef}>
                            <Button variant="outline-secondary" size="sm" onClick={() => this.onToggleSortMenu()} className="sort-button">
                                Ordenar ▼
                            </Button>

                            {showSortMenu && (
                                <div className="sort-dropdown">
                                    <div className="sort-dropdown-header">Ordenar por</div>

                                    {sortableFields.map((field) => (
                                        <div key={field.value} onClick={() => this.onSort(field.value, this.state.sortDirection)} className={`sort-dropdown-item ${sortField === field.value ? "active" : "" }`}>
                                            {field.label}
                                        </div>
                                    ))}

                                    <div className="sort-dropdown-divider"></div>

                                    <div onClick={() => this.onSort(this.state.sortField, "asc")} className={`sort-dropdown-item ${sortDirection === "asc" ? "active" : "" }`} >
                                        Ascendente
                                    </div>

                                    <div onClick={() => this.onSort(this.state.sortField, "desc")} className={`sort-dropdown-item ${sortDirection === "desc" ? "active" : "" }`} >
                                        Descendente
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {typeof onSelectAll === "function" && (
                        <Col xs="auto" style={{ marginLeft: "auto", marginRight: 15 }}>
                            <Button onClick={() => onSelectAll()} disabled={!sortedData || sortedData.length === 0} >
                                Selecionar Tudo
                            </Button>
                        </Col>
                    )}
                </Row>

                <Table style={{ overflowX: "clip", marginTop: "15px" }} striped hover>
                    <tbody>
                        {(!sortedData || sortedData.length === 0) ? (
                            <tr>
                                <td style={{ textAlign: "center" }}>
                                    Sem dados disponíveis!
                                </td>
                            </tr>
                        ) : (
                            sortedData.map(row => (
                                <tr key={row.id} className={`schematicmap selectable ${isRowSelected(row) ? "checked" : ""}`} onClick={() => (isClickable ? onRowClick(row) : null)}>
                                    <td>
                                        {this.props.renderCell(row)}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>
        );
    }
}